import React from "react";
import Dispatcher from "../../dispatcher";
import FractionStore from "../../stores/fraction-store";
import LibraryStore from "../../stores/library-store";
import LibraryActions from "../../actions/library-actions";
import Spinner from "../../components/layouts/spinner";
import showFeedback from "../feedback/feedback-container";
import BookUnavailable from "../gadgets/src/assignments/books/book-unavailable";
import LibraryHelpers from "../../stores/library-helpers";
import ModalManager from "../layouts/modal-manager";
import BookListContainer from "./book-list-container";
import Tour from "../tour/tour";

var FilterContainer = require("./filter-container");
var HeaderContainer = require("../layouts/header-container");
var MainMenu = require("../ui_elements/main-menu").MainMenu;
var CollectionsMenu = require("../ui_elements/collections-menu")
  .CollectionsMenu;
import LoadingContainer from "../layouts/loading-container";
var OnBoardingHelper = require("../onboarding/onboarding-container")
  .OnBoardingHelper;
var ContextModal = require("../ui_elements/context-modal").ContextModal;
import AcceptCookies from "../accept-cookies";

const librarySpinnerStyle = {
  background: "#d5d5e2",
  top: "44px"
};

/*
  Renders the Library View
    props: books, ...
    state: filteredBooks, ...
*/
class Container extends React.Component {
  constructor(props) {
    super(props);
    var userData = Fraction.Helpers.getDataObject("User.Persist");
    var view = userData.library_view || Fraction.Brand.Library.defaultView;
    this.state = {
      books: undefined,
      view: view,
      positionClass: "",
      window: { width: $("#book-list").width(), height: window.innerHeight },
      jigsawBookCount: 0,
      perPage: 1000,
      filter: "all",
      sort: "recent",
      find: "",
      isCollectionsOpen: false,
      bookAccess: false,
      assignmentBooks: []
    };

    this._licenseUpdated = this._licenseUpdated.bind(this);
    this._viewUpdatedBooks = this._viewUpdatedBooks.bind(this);
    this._licenseUpdating = this._licenseUpdating.bind(this);
    this._noAccessToBook = this._noAccessToBook.bind(this);
    this._fractionStoreChange = this._fractionStoreChange.bind(this);
    this._getOnboardingSSOSteps = this._getOnboardingSSOSteps.bind(this);
    this._handleWindowResize = this._handleWindowResize.bind(this);
    this._libraryUpdated = this._libraryUpdated.bind(this);
    this._hasReadBooks = this._hasReadBooks.bind(this);
    this._hasAssignments = this._hasAssignments.bind(this);
    this._getSortedFilteredBooks = this._getSortedFilteredBooks.bind(this);
    this._filterBooksByFind = this._filterBooksByFind.bind(this);
    this._filterByCollection = this._filterByCollection.bind(this);
    this._emojifyMe = this._emojifyMe.bind(this);
    this._showOnboarding = this._showOnboarding.bind(this);
    this._pointToProd = this._pointToProd.bind(this);
    this._pointToDev = this._pointToDev.bind(this);
    this._showFeedbackPopup = this._showFeedbackPopup.bind(this);
    this._resetFeedback = this._resetFeedback.bind(this);
    this._showDebugMenu = this._showDebugMenu.bind(this);
    this._showOnboardingSSO = this._showOnboardingSSO.bind(this);
    this._redraw = this._redraw.bind(this);
    this._openCollections = this._openCollections.bind(this);
    this._removeDebugMenu = this._removeDebugMenu.bind(this);
    this._updateView = this._updateView.bind(this);
    this._updatePositionClass = this._updatePositionClass.bind(this);
    this._updatePowerByClass = this._updatePowerByClass.bind(this);
    this._changeFilter = this._changeFilter.bind(this);
    this._isFiltered = this._isFiltered.bind(this);
    this._changeSort = this._changeSort.bind(this);
    this._hideFilter = this._hideFilter.bind(this);
    this._showFilter = this._showFilter.bind(this);

    // Refs
    this.tourRef = React.createRef();
    this.filterContainerRef = React.createRef();
    this.bookListRef = React.createRef();
  }

  componentDidUpdate() {
    this._hasReadBooks(this.state.books);
  }

  componentDidMount() {
    this._hasAssignments();
    this._isMounted = true;
    if (this.props.unavailableIsbn) {
      this._noAccessToBook();
    }
    Fraction.Helpers.modalRedraw = this._redraw;

    window.addEventListener("resize", this._handleWindowResize);

    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 6);
    Dispatcher.bind(Dispatcher.LIBRARY_UPDATED, this._libraryUpdated);
    Dispatcher.bind(Dispatcher.LICENSE_UPDATED, this._licenseUpdated);
    Dispatcher.bind(Dispatcher.LICENSE_UPDATING, this._licenseUpdating);
    Dispatcher.bind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    Dispatcher.bind(Dispatcher.LOCALE_CHANGE, this._fractionStoreChange);
    Dispatcher.bind(Dispatcher.VIEW_UPDATED_BOOKS_SHOW, this._viewUpdatedBooks);

    this._libraryUpdated();
    LibraryStore.loadBookList();
    LibraryActions.loadAccessCodes();

    // Since we don't have hotkeys, this is hacky and right here for now...
    $(window).on("keyup", e => {
      switch (e.keyCode) {
        case 68:
          if (e.altKey) {
            this._showDebugMenu();
          }
          break;
        default:
          break;
      }
    });

    Fraction.Helpers.getUser(
      function() {
        this._redraw();

        // Check if NPS feedback modal should show
        if (Fraction.Helpers.shouldNPSFeedbackShow()) {
          this._showFeedbackPopup();
        }
      }.bind(this)
    );

    this.readOfflineTimeout = Fraction.Helpers.readOffline(
      false,
      false,
      function() {
        this.onboardingTimeout = OnBoardingHelper._onboarding($(window));
      }.bind(this)
    );

    // TODO: Figure out trigger for this
    // Dispatcher.emit(Dispatcher.NEW_TOUR, this._getOnboardingSSOSteps())
  }

  _licenseUpdated() {}

  _viewUpdatedBooks() {
    this._changeFilter("updated");
  }

  _licenseUpdating(data) {
    if (data.auto) {
      Fraction.Helpers.removeLoader("#bookshelf");
      Fraction.Helpers.removeLoader("header");
      Fraction.Helpers.addLoader(
        "#bookshelf",
        "top:44px;background:#dadada;",
        i18n.t("library.updating-license")
      );
      Fraction.Helpers.addLoader(
        "header",
        "top:0px;height:44px;bottom:auto;background:#40404c;opacity:0.5;",
        i18n.t("library.updating-license")
      );
    }
    this.setState({ hasBooksRead: false });
  }

  _noAccessToBook(e) {
    Jigsaw.getBookInfo(this.props.unavailableIsbn, response => {
      if (response.code !== 401) {
        if (response.code === 404) {
          Fraction.Helpers.removeModal();
        } else if (!response.data.hasLicense) {
          Dispatcher.emit(Dispatcher.END_TOUR);
          Fraction.Helpers.showModal({
            title: "You do not have access to this book",
            content: <BookUnavailable book={response.data} />,
            closeCallback: function() {},
            className: "book-unavailable",
            definingClass: "book-unavailable-container",
            buttons: [],
            fullscreen: true,
            width: 400,
            height: 303
          });
        }
      }
    });
  }

  _fractionStoreChange() {
    this.forceUpdate();
  }

  // TODO: No books case
  _getOnboardingSSOSteps() {
    var steps;

    // First desktop, then mobile steps
    if (!Fraction.Helpers.isSmallScreen()) {
      steps = [
        {
          message: i18n.t("onboarding.open-account-menu"),
          targetSelector: "#user-dropdown-dom-1",
          menuDirection: "bottom",
          hiddenDetailMessage: i18n.t("onboarding.open-account-menu-hidden")
        },
        {
          message: i18n.t("onboarding.download-buttons-message"),
          boldMessage: i18n.t("onboarding.download-buttons-bold-message"),
          targetSelector: ".account-header",
          menuDirection: "left",
          hiddenDetailMessage: i18n.t(
            "onboarding.download-buttons-message-hidden"
          ),
          setup: () => {
            $("[data-menu-id='user-dropdown-menu-1']").click();
          }
        },
        {
          message: i18n.t("onboarding.open-book-message"),
          nextText: i18n.t("onboarding.open-book"),
          targetSelector: ".card:first",
          menuDirection: "right",
          hiddenDetailMessage: i18n.t("onboarding.open-book-message-hidden"),
          teardown: () => {
            var target = $(".card:first");
            Fraction.Router.setRoute(target.find("a").attr("href"));
          }
        },
        {
          message: i18n.t("onboarding.book-menu-message"),
          boldMessage: i18n.t("onboarding.book-menu-bold-message"),
          nextText: i18n.t("base.close"),
          setup: () => {
            setTimeout(() => {
              $("#menu-button").click();
            }, 500);
          },
          timeout: 1500,
          targetSelector: ".read-offline-item",
          menuDirection: "right",
          hiddenDetailMessage: i18n.t("onboarding.book-menu-messagew-hidden")
        }
      ];
    } else {
      steps = [
        {
          message: i18n.t("onboarding.open-menu-mobile"),
          targetSelector: ".menu-icon",
          menuDirection: "bottom",
          hiddenDetailMessage: i18n.t("onboarding.open-menu-mobile-hidden"),
          setup: () => {
            $(".menu-close-container").click();
          }
        },
        {
          message: i18n.t("onboarding.launch-app-mobile"),
          nextText: i18n.t("base.finish"),
          targetSelector: ".read-offline-item",
          menuDirection: "bottom",
          hiddenDetailMessage: i18n.t("onboarding.launch-app-mobile-hidden"),
          setup: () => {
            $(".menu-icon").click();
          }
        },
        {
          message: i18n.t("onboarding.book-menu-message"),
          boldMessage: i18n.t("onboarding.book-menu-bold-message"),
          nextText: i18n.t("base.close"),
          setup: () => {
            $("#menu-button").click();
          },
          targetSelector: ".read-offline-item",
          menuDirection: "right",
          hiddenDetailMessage: i18n.t("onboarding.book-menu-message-hidden")
        }
      ];
    }

    return steps;
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.readOfflineTimeout);
    clearTimeout(this.openCollectionsTimeout);
    clearTimeout(this.resizeWindowEvent);
    clearTimeout(this.onboardingTimeout);
    if (this.feenyInit) {
      this.feenyInit.cancel();
    }
    window.removeEventListener("resize", this._handleWindowResize);
    Fraction.Helpers.removeLoader("header");
    Fraction.Helpers.removeLoader("#bookshelf");

    Dispatcher.unbind(Dispatcher.LIBRARY_UPDATED, this._libraryUpdated);
    Dispatcher.unbind(Dispatcher.LICENSE_UPDATED, this._licenseUpdated);
    Dispatcher.unbind(Dispatcher.LICENSE_UPDATING, this._licenseUpdating);
    Dispatcher.unbind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChange
    );
    Dispatcher.unbind(Dispatcher.LOCALE_CHANGE, this._fractionStoreChange);
    Dispatcher.unbind(
      Dispatcher.VIEW_UPDATED_BOOKS_SHOW,
      this._viewUpdatedBooks
    );
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 6);
    clearTimeout(this.feedbackTimeout);
    LibraryHelpers.exitLibraryCloseToast();
  }

  _handleWindowResize() {
    // A lot of book calculations are happening when the window gets resized
    // which is preventing rendering.  Going to throttle it up here and hopefully
    // abstract it later.  Interestingly enough, if we queue these up correctly, react
    // is okay with them.
    if (this.resizeWindowEvent) {
      clearTimeout(this.resizeWindowEvent);
    }
    this.resizeWindowEvent = setTimeout(() => {
      if (this.filterContainerRef.current) {
        this.filterContainerRef.current._updateFilterTextValues();
      }
      this.setState({
        window: { width: $("#book-list").width(), height: window.innerHeight }
      });
    }, 0);
  }

  _libraryUpdated() {
    Fraction.Helpers.removeLoader("#bookshelf");
    Fraction.Helpers.removeLoader("header");
    if (FractionStore.get()["license-updating"]) {
      Fraction.Helpers.addLoader(
        "#bookshelf",
        "top:44px;background:#dadada;",
        i18n.t("library.updating-license")
      );
    } else if (LibraryStore.get().loadingBookList) {
      this.setState({ loadingBookList: true });
    } else {
      const filtered = this._getSortedFilteredBooks(
        this.state.sort,
        this.state.filter,
        this.state.find,
        this.state.collection
      );
      this.setState({
        books:
          filtered.filtered.length > 0 || this._isFiltered()
            ? filtered.filtered
            : false,
        jigsawBookCount: LibraryStore.get().jigsawBookCount,
        loadingBookList: false
      });
    }
  }

  _hasReadBooks(booklist) {
    if (!booklist || this.state.hasBooksRead) {
      return true;
    }
    if (this._isMounted) {
      const hasBooksRead = booklist.some(book => book.viewedAt);
      if (hasBooksRead) {
        this.setState({ hasBooksRead: true });
      }
    }
  }

  _hasAssignments() {
    if (Feeny) {
      this.feenyInit = Feeny.init({ cancelable: true });
      this.feenyInit.promise
        .then(() => Feeny.Assignments.all())
        .then(assignments => {
          const assignmentBooks = [];
          assignments.data.reduce((books, assignment) => {
            const { vbid } = assignment;
            if (books.indexOf(vbid) === -1) {
              books.push(vbid);
            }
            return books;
          }, assignmentBooks);
          this.setState({ assignmentBooks });
        })
        .catch(error => {
          if (!error.isCanceled) {
            console.error(error);
          }
        });
    }
  }

  _getSortedFilteredBooks(sort, filter, search, collection) {
    let all_books = LibraryStore.get().bookList;
    var found = [],
      filtered = [],
      val = search.toLowerCase();

    //filtered by collection
    function isInCollection(book) {
      return collection.includes(book.isbn);
    }

    if (collection) {
      all_books = all_books.filter(isInCollection);
    }

    if (val.indexOf("type:") === 0) {
      for (var i = all_books.length - 1; i >= 0; i--) {
        var typeQueryString = val.substring(val.indexOf("type:") + 5).trim();
        var bookToAdd = all_books[i];
        switch (typeQueryString) {
          // only need special cases for strings that aren't exact matches for book layouts or vbkTypes
          // right now that means these strings: 'pbk', 'epub', 'dash' for vbkType and 'fixed' or 'reflowable' for layout
          case "pdf":
          case "pd":
            if (bookToAdd.vbkType.toLowerCase().indexOf("pbk") > -1) {
              filtered.unshift(bookToAdd);
            }
            break;
          case "flow":
            if (bookToAdd.layout.toLowerCase().indexOf("reflowable") > -1) {
              filtered.unshift(bookToAdd);
            }
            break;
          default:
            // keep this so new layouts or vbkTypes are auto-filterable
            // does substring matching, so eg. 'reflo' will match 'reflowable'
            if (
              (bookToAdd.layout &&
                bookToAdd.layout.toLowerCase().indexOf(typeQueryString) > -1) ||
              (bookToAdd.vbkType &&
                bookToAdd.vbkType.toLowerCase().indexOf(typeQueryString) > -1)
            ) {
              filtered.unshift(bookToAdd);
            }
        }
      }
    } else {
      for (var j = all_books.length - 1; j >= 0; j--) {
        if (
          all_books[j].title.toLowerCase().indexOf(val) >= 0 ||
          all_books[j].isbn.toLowerCase().indexOf(val) >= 0 ||
          all_books[j].author.toLowerCase().indexOf(val) >= 0
        ) {
          filtered.unshift(all_books[j]);
        }
      }
    }

    for (var q = filtered.length - 1; q >= 0; q--) {
      var parseBuiltAt = Date.parse(filtered[q].builtAt);
      var parseViewedAt = Date.parse(filtered[q].viewedAt);
      var numTwoWeeks = 1300000000;
      if (
        (filter !== "resources" ||
          (filter === "resources" && filtered[q].hasAncillaries)) &&
        (filter !== "read" || (filter === "read" && filtered[q].viewedAt)) &&
        (filter !== "updated" ||
          ((filter === "updated" &&
            filtered[q].viewedAt !== null &&
            parseBuiltAt > parseViewedAt) ||
            (parseViewedAt - parseBuiltAt >= 0 &&
              parseViewedAt - parseBuiltAt < numTwoWeeks &&
              Date.now() - parseBuiltAt < numTwoWeeks))) &&
        (filter !== "assignments" ||
          (filter === "assignments" &&
            this.state.assignmentBooks.indexOf(filtered[q].isbn) !== -1))
      ) {
        found.unshift(filtered[q]);
      }
    }
    if (sort === "az") {
      found = found.sort(function(a, b) {
        return a.title.toLowerCase() < b.title.toLowerCase()
          ? -1
          : a.title.toLowerCase() > b.title.toLowerCase()
          ? 1
          : 0;
      });
    } else if (sort === "za") {
      found = found.sort(function(a, b) {
        return a.title.toLowerCase() < b.title.toLowerCase()
          ? 1
          : a.title.toLowerCase() > b.title.toLowerCase()
          ? -1
          : 0;
      });
    } else if (sort === "added") {
      found = found.sort(function(a, b) {
        return a.addedAt < b.addedAt ? 1 : a.addedAt > b.addedAt ? -1 : 0;
      });
    }

    return { found: found, filtered: filtered };
  }

  // Filter props.books by the given find value
  _filterBooksByFind(find) {
    var filtered = this._getSortedFilteredBooks(
      this.state.sort,
      this.state.filter,
      find,
      this.state.collection
    );
    this.setState({
      books: filtered.found,
      hasFiltered: filtered.filtered.length > 0,
      find: find
    });
    Fraction.Helpers.delayTimeout(
      function() {
        Fraction.Reporter.gaEvent("library/find-books", find);
        Fraction.Reporter.gaEvent("V3/filter", find, "findByInput");
      }.bind(this),
      1000,
      "library-find-books"
    );
  }

  _filterByCollection(collection, title, level) {
    //collection is an array of ISBN's
    var filtered = this._getSortedFilteredBooks(
      this.state.sort,
      this.state.filter,
      this.state.find,
      collection
    );
    this.setState(
      {
        books: filtered.found,
        hasFiltered: filtered.filtered.length > 0,
        collection: collection
      },
      function() {
        this.filterContainerRef.current._updateFilterTextValues();
      }.bind(this)
    );
    Fraction.Reporter.gaEvent(
      "V3/filter",
      "Level " + level,
      "filterByCollection"
    );
  }

  _emojifyMe() {
    // had to make this a separate function so I could redraw it :o
    i18n.emojify();
    this._removeDebugMenu();
    this.forceUpdate();
  }

  _showOnboarding(e) {
    Fraction.Helpers.removeModal(
      function() {
        this.onboardingTimeout = OnBoardingHelper._onboarding($(window), true);
      }.bind(this)
    );
  }

  _pointToProd(e) {
    Fraction.Helpers.setCookie("productionJigsaw", "true", 2);
    Fraction.Helpers.clearStoredBookList();
    window.location.reload();
  }

  _pointToDev(e) {
    Fraction.Helpers.setCookie("productionJigsaw", "");
    Fraction.Helpers.clearStoredBookList();
    window.location.reload();
  }

  _showFeedbackPopup(e) {
    Fraction.Helpers.removeModal(
      function() {
        clearTimeout(this.feedbackTimeout);
        this.feedbackTimeout = showFeedback($(window), true);
      }.bind(this)
    );
  }

  _resetFeedback(e) {
    Fraction.Helpers.removeModal(
      function() {
        var suffix = "-" + Fraction.User.email.hashMe().toString();
        Fraction.Helpers.getDataObject("User.Persist")[
          "NPSLog" + suffix
        ] = null;

        // Save new data
        Fraction.Helpers.savePersist();

        Fraction.Helpers.setUserInfo({ nps: false }, function() {
          Fraction.Helpers.getUser(function() {}, { refresh: true });
        });
      }.bind(this)
    );
  }

  _showDebugMenu() {
    Fraction.Reporter.addEvent("Open Debug Panel");
    this.debugPanelFlowId = Fraction.Reporter.startFlow("Debug Panel");

    // Add flag for NPS feedback to mark as debug
    Fraction.User.debugMenuOpened = true;

    var debugMenu = (
      <div className="debug-menu">
        <button onClick={Fraction.Helpers.resetPersist}>Clear User Data</button>
        <button onClick={this._emojifyMe}>Emojify</button>
        <button onClick={this._showOnboarding}>OnBoarding</button>
        {window.pointingAtProd ? (
          <button onClick={this._pointToDev}>Point To Dev</button>
        ) : (
          <button onClick={this._pointToProd}>Point To Prod</button>
        )}
        <button onClick={this._showFeedbackPopup}>Feedback</button>
        <button onClick={this._resetFeedback}>Reset Feedback</button>
        <button onClick={this._showOnboardingSSO}>Onboarding SSO Tour</button>
        <button
          onClick={() =>
            OnBoardingHelper._sharingOnboarding($(window), "news", true)
          }
        >
          What's New
        </button>
        <button
          onClick={() =>
            OnBoardingHelper._sharingOnboarding($(window), "educator", true)
          }
        >
          Educator Onboarding
        </button>
        <button
          onClick={() =>
            OnBoardingHelper._sharingOnboarding($(window), "student", true)
          }
        >
          Student Onboarding
        </button>
      </div>
    );
    Fraction.Helpers.showModal({
      title: "Debug Menu",
      content: debugMenu,
      closeCallback: this._removeDebugMenu,
      buttons: [
        {
          label: i18n.t("base.close"),
          click: this._removeDebugMenu,
          color: "gray"
        }
      ]
    });
  }

  _showOnboardingSSO() {
    Fraction.Helpers.removeModal();
    Dispatcher.emit(Dispatcher.NEW_TOUR, this._getOnboardingSSOSteps());
  }

  _redraw() {
    if (this._isMounted) {
      this.forceUpdate();
    }
  }

  _openCollections() {
    Dispatcher.emit(Dispatcher.CLOSE_MENU);
    this.setState(
      { isCollectionsOpen: !this.state.isCollectionsOpen },
      function() {
        if (this.state.isCollectionsOpen) {
          Fraction.Reporter.gaEvent("V3/filter", "click", "openCollections");
        } else {
          Fraction.Reporter.gaEvent("V3/filter", "click", "closeCollections");
        }
        clearTimeout(this.openCollectionsTimeout);
        this.openCollectionsTimeout = setTimeout(
          function() {
            this.setState({
              window: {
                width: $("#book-list").width(),
                height: this.state.window.height
              }
            });
            if (this.filterContainerRef.current) {
              this.filterContainerRef.current._updateFilterTextValues();
            }
          }.bind(this),
          250
        );
      }.bind(this)
    );
  }

  _removeDebugMenu() {
    Fraction.Helpers.removeModal();
    Fraction.Reporter.stopFlow(this.debugPanelFlowId);
    Fraction.Reporter.addEvent("Close Debug Panel");
  }

  _updateView(view) {
    this.setState({ view: view });

    if (Fraction.Brand.Library.gridView && Fraction.Brand.Library.listView) {
      // If you don't have a choice, let's not save it.
      var userData = Fraction.Helpers.getDataObject("User.Persist");
      userData.library_view = view;
      Fraction.Helpers.savePersist();
    }
  }

  _updatePositionClass(positionState) {
    this.setState({ positionState });
  }

  _updatePowerByClass(powerByPositionSt) {
    if (this._isMounted) {
      this.setState({
        powerByPositionSt: powerByPositionSt
      });
    }
  }

  _changeFilter(newFilter) {
    this.setState(
      prevState => ({ filter: newFilter }),
      () => {
        var filtered = this._getSortedFilteredBooks(
          this.state.sort,
          this.state.filter,
          this.state.find,
          this.state.collection
        );
        this.setState({
          books: filtered.found,
          hasFiltered: filtered.filtered.length > 0
        });
      }
    );
    Fraction.Reporter.gaEvent("library/filter-books", newFilter);
    Fraction.Reporter.gaEvent("V3/filter", newFilter, "filterByType");
  }

  _isFiltered() {
    return (
      this.state.filter !== "all" ||
      (this.state.find && this.state.find.length > 0)
    );
  }

  _changeSort(newSort) {
    this.setState(
      prevState => ({ sort: newSort }),
      () => {
        var filtered = this._getSortedFilteredBooks(
          this.state.sort,
          this.state.filter,
          this.state.find,
          this.state.collection
        );
        this.setState({
          books: filtered.found,
          hasFiltered: filtered.filtered.length > 0
        });
      }
    );
    Fraction.Reporter.gaEvent("library/sort-books", newSort);
  }

  _hideFilter() {
    $("#library-filter").css("top", "-4px");
    $("#library").css("padding-top", "0");
  }

  _showFilter(scrollTop) {
    $("#library-filter").css("top", "44px");
    $("#library").css("padding-top", "48px");
  }

  render() {
    return (
      <div key={`library-lang-${i18n.getCurrentLocale()}`}>
        <AcceptCookies />
        <Tour ref={this.tourRef} bookCount={this.state.jigsawBookCount} />
        <HeaderContainer
          positionState={this.state.positionState}
          powerByPositionSt={this.state.powerByPositionSt}
          updatePowerByClass={this._updatePowerByClass}
          searchOnOpen={this.props.searchOnOpen}
          assignmentCreatorOpen={this.props.assignmentCreatorOpen}
          assignmentReaderOpen={this.props.assignmentReaderOpen}
        />
        {this.state.books && (
          <FilterContainer
            ref={this.filterContainerRef}
            updatePositionClass={this._updatePositionClass}
            positionState={this.state.positionState}
            openCollections={this._openCollections}
            onFilterChange={this._filterBooksByFind}
            onViewChange={this._updateView}
            changeFilter={this._changeFilter}
            changeSort={this._changeSort}
            totalAmount={this.state.jigsawBookCount}
            filter={this.state.filter}
            filteredAmount={this.state.books ? this.state.books.length : 0}
            loadingBookList={this.loadingBookList}
            sort={this.state.sort}
            view={this.state.view}
            isCollectionsOpen={this.state.isCollectionsOpen}
            hasBooksRead={this.state.hasBooksRead}
            hasFiltered={this.state.hasFiltered}
            collection={this.state.collection}
          />
        )}
        <div
          id="library"
          aria-hidden={FractionStore.get()["modal-open"]}
          role="main"
        >
          <h1 className="offScreen">{i18n.t("main-menu.library")}</h1>
          <BookListContainer
            positionState={this.state.positionState}
            books={this.state.books}
            view={this.state.view}
            sort={this.state.sort}
            hideFilter={this._hideFilter}
            showFilter={this._showFilter}
            filter={this.state.filter}
            find={this.state.find}
            hasFiltered={this.state.hasFiltered}
            window={this.state.window}
            loadingBookList={this.loadingBookList}
            isCollectionsOpen={this.state.isCollectionsOpen}
            ref={this.bookListRef}
          />
          <MainMenu
            powerByPositionSt={this.state.powerByPositionSt}
            updatePowerByClass={this._updatePowerByClass}
            environment="library"
          />
          <CollectionsMenu
            totalAmount={this.state.jigsawBookCount}
            filterByCollection={this._filterByCollection}
            isCollectionsOpen={this.state.isCollectionsOpen}
            openCollections={this._openCollections}
          />
          {this.state.loadingBookList && (
            <Spinner styles={librarySpinnerStyle} />
          )}
        </div>

        {Fraction.Helpers.modalToShow}
        <ModalManager />
        {!Fraction.User && <LoadingContainer />}
      </div>
    );
  }
}

module.exports = Container;
